import React from "react";

const IconHardwoodFloors = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.812 3.99133C11.4575 2.86487 9.71657 2.18737 7.81715 2.18737C3.50001 2.18737 1.90735e-06 5.68738 1.90735e-06 10.0045C1.90735e-06 12.5585 1.22486 14.8263 3.11915 16.2528L17.9527 27.996C19.3072 29.1225 21.0481 29.8 22.9475 29.8C27.2647 29.8 30.7647 26.3 30.7647 21.9828C30.7647 19.4286 29.5396 17.161 27.6456 15.7345L12.812 3.99133Z"
      fill="url(#paint0_linear_2_96)"
    />
    <path
      d="M22.9475 29.8001C24.928 29.8001 26.7364 29.0631 28.1138 27.8487C25.5557 25.92 21.7361 23.3497 17.5613 21.6058C10.0911 18.4854 11.2259 14.1356 6.87623 11.6771C2.52662 9.21857 5.83595 10.826 4.22852 8.17853C3.35816 6.74493 2.15528 6.0877 1.23487 5.78619C0.453372 7.00323 1.90735e-06 8.45099 1.90735e-06 10.0047C1.90735e-06 12.5587 1.22486 14.8265 3.11915 16.253L17.9527 27.9962C19.3072 29.1227 21.0481 29.8001 22.9475 29.8001V29.8001Z"
      fill="url(#paint1_linear_2_96)"
    />
    <path
      d="M27.6454 15.7345L12.8119 3.99133C11.4574 2.86487 9.71639 2.18737 7.81697 2.18737C7.32845 2.18737 6.85017 2.23254 6.38631 2.31848C7.1993 3.70569 8.34212 5.30139 9.64535 6.09607C12.2301 7.672 13.8692 9.75257 16.8321 12.0219C19.7953 14.2914 22.7582 15.4892 22.7582 15.4892L30.5826 23.6642C30.7013 23.1225 30.7645 22.56 30.7645 21.9828C30.7645 19.4286 29.5394 17.161 27.6454 15.7345V15.7345Z"
      fill="url(#paint2_linear_2_96)"
    />
    <path
      d="M20.237 20.4067C20.237 20.4067 16.5175 19.9023 13.6806 15.5525C10.8437 11.2024 6.24163 7.86129 6.24163 7.86129C6.24163 7.86129 12.2306 9.68942 14.8154 13.0307C17.4001 16.3718 20.237 20.4067 20.237 20.4067Z"
      fill="url(#paint3_linear_2_96)"
    />
    <path
      d="M27.6461 15.7345L19.2587 9.09436C19.0697 9.08728 18.8934 9.07629 18.7345 9.06286C18.1376 9.01208 17.7123 9.63782 17.9796 10.1742C18.0758 10.3671 18.201 10.5233 18.3436 10.6515L24.6788 16.9867C25.494 17.903 27.1403 17.6012 27.1403 17.6012C27.8331 17.4935 28.4537 17.2951 29.0065 17.0436C28.6073 16.5546 28.1505 16.1144 27.6461 15.7345V15.7345Z"
      fill="url(#paint4_linear_2_96)"
    />
    <path
      d="M30.7639 21.9826C30.7639 26.3 27.4395 29.8525 23.3386 29.8525C18.5127 29.8525 15.9133 26.9303 15.9133 22.6132C15.9133 18.2958 19.2376 14.1654 23.3386 14.1654C27.4395 14.1654 30.7639 17.6654 30.7639 21.9826V21.9826Z"
      fill="url(#paint5_radial_2_96)"
    />
    <path
      d="M24.1561 29.7551C21.8221 29.551 17.8186 27.3384 17.8186 24.2512C17.8186 19.1574 21.24 17.4084 24.2984 17.4685C28.0948 17.5429 32.1754 22.4324 29.1866 26.3188C27.6509 28.3157 23.9224 28.7212 21.8479 26.709C20.5845 25.4836 20.2559 23.2807 21.085 21.9646C23.0877 18.7851 27.1705 20.5339 26.8548 22.8589C26.8162 23.1443 26.7349 23.3713 26.6224 23.5498C26.2725 24.1057 25.4566 23.6494 25.68 23.0268C25.711 22.9402 25.7339 22.8442 25.7474 22.7375C25.9329 21.2546 23.2098 20.7387 22.3433 22.0283C21.4769 23.3179 22.0958 25.3813 23.7667 25.8328C25.4378 26.2842 27.8445 25.7248 28.3538 24.2485C29.0455 22.2439 28.0779 18.8833 24.2984 18.7043C21.2425 18.5595 18.835 20.8181 18.835 24.2514C18.835 27.3384 21.8218 29.551 24.1561 29.7551V29.7551Z"
      fill="url(#paint6_linear_2_96)"
    />
    <path
      d="M23.7385 29.7551C21.4353 29.5425 17.4846 27.2371 17.4846 24.0203C17.4846 18.7126 20.8611 16.8901 23.8791 16.9526C27.6255 17.0303 31.6523 22.1248 28.7029 26.1746C27.1875 28.2551 23.508 28.6777 21.4609 26.5813C20.2141 25.3042 19.8899 23.0088 20.708 21.6375C22.6845 18.3245 26.7134 20.1467 26.4018 22.5693C26.3635 22.8667 26.2834 23.1033 26.1726 23.2893C25.8271 23.8684 25.022 23.3931 25.2424 22.7444C25.2729 22.6541 25.2956 22.554 25.3088 22.4431C25.4919 20.8977 22.8047 20.3601 21.9497 21.7039C21.0947 23.0476 21.7053 25.1978 23.3545 25.668C25.0034 26.1384 27.3784 25.5557 27.8811 24.0173C28.5635 21.9285 27.6086 18.4268 23.8789 18.2402C20.8635 18.0894 18.4878 20.4429 18.4878 24.0203C18.4878 27.2371 21.4353 29.5425 23.7385 29.7551V29.7551Z"
      fill="url(#paint7_linear_2_96)"
    />
    <path
      d="M24.4071 9.14395C24.4071 9.14395 29.5036 4.76528 31.9714 12.9286C32.0744 13.2694 31.8879 13.6298 31.5514 13.7465C29.9355 14.3083 25.4635 15.2631 24.4071 9.14395V9.14395Z"
      fill="url(#paint8_linear_2_96)"
    />
    <path
      d="M31.5517 13.7465C31.738 13.6818 31.8781 13.5422 31.9486 13.3725C28.6354 10.9411 24.4071 9.14399 24.4071 9.14399C25.4635 15.2631 29.9355 14.3083 31.5517 13.7465Z"
      fill="url(#paint9_linear_2_96)"
    />
    <path
      d="M29.3592 12.5947C29.3292 12.5327 29.3038 12.4685 29.2777 12.4052C29.2513 12.3423 29.2252 12.2798 29.2025 12.2158C29.1786 12.1523 29.1637 12.0852 29.1478 12.0193C29.1322 11.9533 29.107 11.8925 29.0721 11.8349C29.0365 11.778 28.9984 11.7226 28.9525 11.6679C29.0362 11.7085 29.1202 11.7487 29.2042 11.789L29.6119 11.9912C29.7484 12.0581 29.8795 12.1325 30.015 12.2014C30.2831 12.3437 30.5438 12.4953 30.795 12.6653L30.8414 12.612L30.672 12.4541L30.5868 12.3747C30.5577 12.3491 30.5275 12.3257 30.4977 12.301C30.3773 12.2058 30.2589 12.1042 30.1339 12.0154C29.8878 11.8296 29.6337 11.6574 29.3797 11.4834C29.3299 11.4511 29.2801 11.4189 29.2306 11.3867C29.2797 11.3813 29.328 11.3725 29.3754 11.3559C29.4393 11.3337 29.504 11.3098 29.5704 11.2956C29.6363 11.2802 29.7032 11.2683 29.7704 11.2563C29.8375 11.2441 29.9054 11.2307 29.9737 11.2224C30.1107 11.1994 30.2491 11.1892 30.3915 11.1748L30.3968 11.136C30.2611 11.0888 30.1205 11.0517 29.9772 11.0266C29.9056 11.0134 29.8334 11.0051 29.7606 10.9958C29.6881 10.9904 29.6151 10.9851 29.5419 10.9836C29.4684 10.9814 29.3942 10.9751 29.3194 10.9721C29.245 10.9707 29.1717 10.9817 29.1019 11.008C29.0882 11.0134 29.0746 11.0188 29.0609 11.0246C28.9134 11.0881 28.7438 11.0727 28.607 10.9882L28.6046 10.9865C28.3668 10.8396 28.1263 10.698 27.8863 10.5549C27.9552 10.5461 28.0191 10.5317 28.0824 10.5146C28.1471 10.4958 28.2069 10.4685 28.2633 10.4306C28.3194 10.393 28.3761 10.3537 28.4369 10.3235C28.4969 10.292 28.5587 10.2636 28.6207 10.2351C28.6827 10.2065 28.745 10.1767 28.8092 10.1516C28.9359 10.0949 29.0675 10.0505 29.2015 10.0009L29.1969 9.96188C29.0538 9.9504 28.9083 9.94943 28.7635 9.96114C28.6908 9.96603 28.619 9.97604 28.5463 9.98556C28.4745 9.9985 28.4025 10.0117 28.3312 10.0285C28.2596 10.0446 28.1861 10.0571 28.1131 10.073C28.0406 10.0903 27.9723 10.1191 27.9112 10.1621C27.8846 10.1814 27.8583 10.2019 27.8329 10.2238C27.7093 10.3308 27.5284 10.3401 27.389 10.2546C27.2694 10.1814 27.1498 10.1076 27.0296 10.0351C26.8775 9.94308 26.7213 9.85909 26.5621 9.78121C26.6212 9.77218 26.6771 9.75948 26.7323 9.74435C26.797 9.72579 26.8568 9.69845 26.9129 9.66036C26.9693 9.62276 27.026 9.58346 27.0868 9.55343C27.1466 9.52169 27.2084 9.49361 27.2706 9.46505C27.3324 9.43648 27.3949 9.40646 27.4588 9.38155C27.5856 9.32491 27.7171 9.28048 27.8514 9.23092L27.8468 9.19185C27.7037 9.18014 27.5582 9.1794 27.4132 9.19088C27.3407 9.19601 27.2687 9.20601 27.1959 9.21554C27.1244 9.22848 27.0521 9.24142 26.9808 9.25826C26.9095 9.27462 26.836 9.28707 26.7628 9.30294C26.6905 9.32003 26.6222 9.34908 26.5611 9.39205C26.5011 9.43526 26.4432 9.48458 26.3932 9.54415C26.3358 9.61227 26.243 9.63839 26.16 9.60616C25.9447 9.5234 25.5543 9.37643 25.3412 9.3127C25.044 9.22603 24.7418 9.15011 24.4227 9.11226L24.3929 9.17623C24.6256 9.39669 24.8729 9.58443 25.1249 9.76168C25.3773 9.93795 25.6354 10.1015 25.8985 10.2541C25.9032 10.2568 25.9078 10.2595 25.9125 10.2622C25.9974 10.3115 26.0335 10.4116 26.0064 10.5061C25.9864 10.5754 25.9774 10.6457 25.9737 10.7148C25.9708 10.7895 25.9833 10.8625 26.0079 10.9328C26.0343 11.0029 26.0636 11.0713 26.0885 11.1401C26.1129 11.2092 26.1407 11.2771 26.1688 11.3442C26.2001 11.4106 26.2306 11.4765 26.2657 11.5403C26.3343 11.6684 26.4137 11.7903 26.5008 11.9043L26.5362 11.8872C26.5052 11.7475 26.4715 11.6128 26.4505 11.4756C26.4371 11.4082 26.4283 11.3396 26.419 11.2719C26.4093 11.2043 26.3998 11.1372 26.3937 11.0695C26.3863 11.0022 26.3888 10.9333 26.39 10.8654C26.3912 10.7978 26.3819 10.7324 26.3627 10.6679C26.3407 10.5984 26.3146 10.5295 26.2794 10.4592C26.4222 10.5302 26.5672 10.5964 26.7147 10.6579C26.8329 10.706 26.9916 10.7727 27.1307 10.8318C27.2787 10.8945 27.3741 11.0446 27.359 11.2048C27.3514 11.2829 27.3556 11.3618 27.3517 11.4338C27.3487 11.5083 27.3612 11.5813 27.3858 11.6516C27.4122 11.7216 27.4415 11.7903 27.4664 11.8591C27.4908 11.9282 27.5189 11.9961 27.5467 12.0632C27.578 12.1294 27.6085 12.1953 27.6437 12.2592C27.7123 12.3872 27.7916 12.5092 27.879 12.6233L27.9142 12.6062C27.8832 12.4665 27.8495 12.3318 27.8285 12.1943C27.815 12.1269 27.8063 12.0583 27.797 11.9907C27.7872 11.9231 27.7777 11.8559 27.7718 11.7883C27.7643 11.7209 27.7667 11.6521 27.7679 11.5844C27.7691 11.5166 27.7599 11.4514 27.7406 11.3869C27.7018 11.2644 27.6512 11.1438 27.5565 11.0136C27.8314 11.1413 28.108 11.2668 28.3807 11.3984L28.3915 11.4033C28.5592 11.4797 28.6778 11.6408 28.6871 11.8247C28.6896 11.8767 28.6971 11.9277 28.7071 11.9773C28.7228 12.0503 28.7533 12.1179 28.7948 12.1799C28.8375 12.2409 28.8832 12.3 28.9247 12.3606C28.9654 12.4214 29.0096 12.48 29.0533 12.5381C29.1005 12.5942 29.1463 12.6506 29.1964 12.7036C29.295 12.8103 29.4022 12.9084 29.5152 12.997L29.545 12.9717C29.4803 12.8442 29.4139 12.7221 29.3592 12.5947V12.5947Z"
      fill="url(#paint10_linear_2_96)"
    />
    <path
      d="M18.7345 9.06296C20.2172 9.18869 23.13 9.12863 25.3356 7.16427C25.4596 7.05392 25.6305 7.00411 25.7924 7.04171C25.9908 7.0881 26.1451 7.25778 25.785 7.79831C25.1547 8.74387 23.5155 10.6982 20.6786 11.1394C20.6786 11.1394 18.6468 11.5127 17.9796 10.1743C17.7123 9.63791 18.1376 9.01242 18.7345 9.06296V9.06296Z"
      fill="url(#paint11_linear_2_96)"
    />
    <path
      d="M22.2842 8.8359C22.2842 8.8359 18.9619 7.06612 22.7212 4.11763C22.8782 3.99458 23.1043 4.01875 23.2337 4.17036C23.8555 4.89986 25.2635 7.04 22.2842 8.8359V8.8359Z"
      fill="url(#paint12_linear_2_96)"
    />
    <path
      d="M23.2327 4.17033C23.161 4.0861 23.0596 4.04142 22.9566 4.03922C22.3614 6.26335 22.2833 8.83587 22.2833 8.83587C25.2625 7.03996 23.8546 4.89982 23.2327 4.17033Z"
      fill="url(#paint13_linear_2_96)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2_96"
        x1="16.1621"
        y1="14.811"
        x2="10.4886"
        y2="23.4159"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C08552" />
        <stop offset="1" stopColor="#895738" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2_96"
        x1="11.4378"
        y1="20.0137"
        x2="21.5246"
        y2="10.053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#895738" stopOpacity="0" />
        <stop offset="1" stopColor="#5E3023" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2_96"
        x1="19.7338"
        y1="10.8418"
        x2="15.4469"
        y2="18.2178"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#895738" stopOpacity="0" />
        <stop offset="1" stopColor="#5E3023" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2_96"
        x1="13.7355"
        y1="13.2802"
        x2="11.2023"
        y2="17.6388"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#895738" stopOpacity="0" />
        <stop offset="1" stopColor="#5E3023" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2_96"
        x1="23.6912"
        y1="14.0859"
        x2="20.9803"
        y2="7.59253"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#895738" stopOpacity="0" />
        <stop offset="1" stopColor="#5E3023" />
      </linearGradient>
      <radialGradient
        id="paint5_radial_2_96"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.3386 22.0089) scale(7.63728)"
      >
        <stop stopColor="#F2E9DC" />
        <stop offset="0.4935" stopColor="#F1E7DA" />
        <stop offset="0.6712" stopColor="#EFE2D3" />
        <stop offset="0.7979" stopColor="#EAD8C8" />
        <stop offset="0.8997" stopColor="#E4CAB7" />
        <stop offset="0.9865" stopColor="#DCB7A1" />
        <stop offset="1" stopColor="#DAB49D" />
      </radialGradient>
      <linearGradient
        id="paint6_linear_2_96"
        x1="29.112"
        y1="26.2511"
        x2="16.8597"
        y2="19.5998"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DAB49D" stopOpacity="0" />
        <stop offset="0.4385" stopColor="#CE9E7A" stopOpacity="0.439216" />
        <stop offset="1" stopColor="#C08552" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2_96"
        x1="23.9955"
        y1="21.4098"
        x2="21.445"
        y2="33.5011"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DAB49D" />
        <stop offset="0.9668" stopColor="#C08552" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2_96"
        x1="28.5734"
        y1="10.5991"
        x2="25.8658"
        y2="15.1123"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ACC130" />
        <stop offset="1" stopColor="#97A03B" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2_96"
        x1="27.3548"
        y1="13.2059"
        x2="28.9691"
        y2="9.36988"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#97A03B" stopOpacity="0" />
        <stop offset="1" stopColor="#575C55" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2_96"
        x1="28.2022"
        y1="9.98885"
        x2="27.4755"
        y2="11.0928"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#97A03B" />
        <stop offset="1" stopColor="#6C7D47" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_2_96"
        x1="21.983"
        y1="8.70213"
        x2="22.8341"
        y2="11.5706"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C08552" />
        <stop offset="1" stopColor="#895738" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_2_96"
        x1="21.9729"
        y1="5.46743"
        x2="23.3265"
        y2="7.85896"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE548" />
        <stop offset="0.9688" stopColor="#97A03B" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_2_96"
        x1="23.241"
        y1="6.32914"
        x2="20.7392"
        y2="6.76592"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#97A03B" stopOpacity="0" />
        <stop offset="1" stopColor="#575C55" />
      </linearGradient>
    </defs>
  </svg>
);

export default IconHardwoodFloors;
